import React from 'react';
import LiquidLiquidForm from '../../components/forms/liquidLiquidForm';

const LiquidLiquid: React.SFC<any> = (props) => (
  <LiquidLiquidForm {...props} />
);

export default LiquidLiquid;
